import { get } from 'lodash';
import { getDefaultSiteLocale, getLocales } from '@wix/communities-blog-client-common';
import { getBasicParams } from '../store/basic-params/basic-params-selectors';
import { type AppState } from '../types';

export const getLocale = (state: AppState) => get(state, 'locale.current');
export const getQueryLocale = (state: AppState) => get(state, 'locale.query');

export function getLanguageCode(state: AppState) {
  const locale = getQueryLocale(state);
  const language = getBasicParams(state).language;
  const languageCode =
    locale ||
    language ||
    (getLocales(state as any) && getDefaultSiteLocale(state as any)?.id) ||
    null;

  return languageCode;
}
